import lodash from 'lodash'
import { useMemo } from 'react'

import { euList } from '../../../../../1stlog-ui/src/components/CountryPicker/utils'
import { useField } from '../../../../../1stlog-ui/src/components/Field'
import useOrderEntry from '../../useOrderEntry'

const CUSTOM_FREE_COUNTRIES = ['CH', 'LI']

const useCustoms = () => {
  const { preset, currentCustomer } = useOrderEntry()

  const { showCustoms } = preset

  const senderCountry = useField('pickup.address.country', {
    ignorePrefix: true,
  })
  const receiverCountry = useField('delivery.address.country', {
    ignorePrefix: true,
  })

  const isCustomsRequired =
    isInternational(senderCountry, receiverCountry) && showCustoms

  const isCrossingEu = useMemo(() => {
    const isSenderEu = isInEu(senderCountry)
    const isReceiverEu = isInEu(receiverCountry)
    return (isSenderEu && !isReceiverEu) || (!isSenderEu && isReceiverEu)
  }, [senderCountry, receiverCountry])

  return { isCustomsRequired, isCrossingEu }
}

export default useCustoms

function isInEu(country) {
  return !!lodash.find(
    euList,
    (code) => lodash.toLower(code) === lodash.toLower(country),
  )
}

export function isInternational(country1, country2) {
  const euCustomsCountries = [
    'BE',
    'BG',
    'DK',
    'DE',
    'EE',
    'FI',
    'FR',
    'GR',
    'IE',
    'IT',
    'HR',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'AT',
    'PL',
    'PT',
    'RO',
    'SE',
    'SK',
    'SI',
    'ES',
    'CZ',
    'HU',
    'CY',
  ]
  const customRelationCountries = {
    CH: ['CH', 'LI'],
    LI: ['CH', 'LI'],
    NO: ['NO'],
  }
  euCustomsCountries.forEach((country) => {
    customRelationCountries[country] = euCustomsCountries
  })

  if (
    customRelationCountries[country1] &&
    customRelationCountries[country1].includes(country2)
  ) {
    return false
  }
  if (
    customRelationCountries[country2] &&
    customRelationCountries[country2].includes(country1)
  ) {
    return false
  }
  return true
}
